import { Select } from 'antd';
import React, { memo } from 'react';
import './AppInputSelector.scss';

export type SelectableOption = {
  value: string;
  label: string;
};

type AppInputSelectorProps = {
  containerClassName?: string;
  label: string;
  placeholder?: string;
  allowClear?: boolean;
  selectedValue?: string;
  options: SelectableOption[];
  onChange: (value: string) => void;
};

const AppInputSelector: React.FC<AppInputSelectorProps> = ({
  containerClassName,
  label,
  placeholder,
  allowClear,
  selectedValue,
  options,
  onChange,
}) => {
  return (
    <div className={`app-input-selector-container ${containerClassName}`}>
      <p className="app-input-selector-label">{label}</p>
      <Select
        value={selectedValue}
        onChange={onChange}
        options={options} style={{ width: '100%' }}
        placeholder={placeholder}
        allowClear={allowClear}
        onClear={() => {
          onChange('')
        }}
      />
    </div>
  );
};

export default memo(AppInputSelector);
